module.exports = __webpack_public_path__ + "media/images/icon-shop-success-83a62d61be6cf6e76b4cf10dd20e53de.svg";